import { type FC } from 'react'

import { algoliaProxyRecordAccessorGetDeeplink } from '../../../algolia'
import { experimentsCompeteraTrackCompeteraEvent } from '../../../experiments/competera-experiment/experimentsCompeteraTrackCompeteraEvent'
import { useExperimentsContext } from '../../../experiments/components/ExperimentsContext'
import {
  EXPERIMENTS_TRACK_EVENT_SEARCH_PAGE_PRODUCT_DETAIL_CLICK,
  EXPERIMENTS_TRACK_EVENT_SERP_COMPETERA,
  experimentsTrackEvent,
} from '../../../experiments/eventTracking'
import { useGetExperiment } from '../../../experiments/hooks'
import { EXPERIMENT_NAME_SEARCH_PAGE_REFINED_QUERY_SUGGESTIONS } from '../../../experiments/model/EXPERIMENT_NAME.ts'
import { useGlobalConfigContext } from '../../../global-config'
import { ProductPicture } from '../../../product'
import { useProductSearchContext } from '../../context/productSearchContextValue.tsx'

import { useProductSearchResultItemContext } from './ProductSearchResultItemContext/productSearchResultItemContext'

const MAX_IMAGE_SIZE = 100

export const ProductSearchResultItemImage: FC = () => {
  const { algoliaRecord, query = '' } = useProductSearchResultItemContext()
  const { skipProductDeepLinkParams } = useProductSearchContext()

  const { experiments } = useExperimentsContext()

  const {
    __position: position,
    __queryID: queryID = '',
    image,
    offerId,
    productName,
  } = algoliaRecord
  const globalConfig = useGlobalConfigContext()

  const searchPageRefinedQuerySuggestionsExperiment = useGetExperiment(
    EXPERIMENT_NAME_SEARCH_PAGE_REFINED_QUERY_SUGGESTIONS,
  )

  return (
    // Switching to `NextLink` investigation under https://jira.shop-apotheke.com/browse/WSAWA-7078
    <a
      className="z-10 shrink-0"
      data-qa-id="serp-result-item-image"
      href={algoliaProxyRecordAccessorGetDeeplink({
        params: {
          eventName: 'click on product image',
          offerId,
          position,
          query,
          queryID,
        },
        record: algoliaRecord,
        skipProductDeepLinkParams,
      })}
      onClick={(): void => {
        experimentsCompeteraTrackCompeteraEvent(
          experiments,
          globalConfig,
          EXPERIMENTS_TRACK_EVENT_SERP_COMPETERA,
        )
        if (searchPageRefinedQuerySuggestionsExperiment.isEnabled) {
          experimentsTrackEvent(
            globalConfig,
            EXPERIMENTS_TRACK_EVENT_SEARCH_PAGE_PRODUCT_DETAIL_CLICK,
          )
        }
      }}
    >
      <ProductPicture
        className="size-[70px] tablet:size-[100px]"
        imageProps={{
          alt: productName,
          'data-analytics': 'item-image',
          height: MAX_IMAGE_SIZE,
          src: image,
          width: MAX_IMAGE_SIZE,
        }}
      />
    </a>
  )
}
